import React from 'react';
import { BRAND, stats, testimonials } from '../data/sushiContent';
type TestimonialsSectionProps = {
  /** The first appearance carries the statistics strip. */
  variant?: 'primary' | 'compact';
  id?: string;
};
export function TestimonialsSection({
  variant = 'primary',
  id = 'proof'
}: TestimonialsSectionProps) {
  const isPrimary = variant === 'primary';
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby={`${id}-title`} data-id="element-267" data-mp="1d1uozla6dvqa">
      <div className="mx-auto max-w-6xl px-5" data-id="element-268" data-mp="1i0nzr5y2v8mr">
        {isPrimary ? <h2 id={`${id}-title`} className="sr-only" data-id="element-269" data-mp="1hyl3i46c0j9l">
            Lo que dicen de {BRAND}
          </h2> : <h2 id={`${id}-title`} className="text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-270" data-mp="182i1cybhckmn">
            Lo que dicen de {BRAND}
          </h2>}

        {isPrimary && <dl className="grid grid-cols-2 gap-y-6 border-b border-charcoal-600 pb-10 sm:grid-cols-4" data-id="element-271" data-mp="32egc54pftokn">
            {stats.map(s => <div key={s.label} className="text-center" data-id="element-272" data-mp="2q311kblqkbxl">
                <dd className="font-display text-2xl font-semibold text-champagne sm:text-3xl" data-id="element-273" data-mp="2q0euse6o60gf">
                  {s.value}
                </dd>
                <dt className="mx-auto mt-1 max-w-[8rem] text-[9px] font-medium uppercase tracking-[0.16em] text-muted sm:text-[10px]" data-id="element-274" data-mp="2zs160aj0bzj6">
                  {s.label}
                </dt>
              </div>)}
          </dl>}

        <ul className={`grid gap-3 sm:grid-cols-3 ${isPrimary ? 'mt-10' : 'mt-8'}`} data-id="element-275" data-mp="275ghdhtx21jb">
          {testimonials.map(t => <li key={t.name} className="flex flex-col border border-charcoal-600 bg-charcoal-800 p-5" data-id="element-276" data-mp="2h1t7y6u5zz9u">
              <div className="flex items-center gap-3" data-id="element-277" data-mp="19cctyu9cpki">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-champagne/40 text-[11px] font-semibold tracking-[0.08em] text-champagne" aria-hidden="true" data-id="element-278" data-mp="3sgyk01g6ra64">
                  {t.initials}
                </span>
                <span className="text-[10px] tracking-[0.2em] text-champagne" aria-label="5 de 5 estrellas" data-id="element-279" data-mp="dd81bai4oyk8">
                  ★★★★★
                </span>
              </div>
              <blockquote className="mt-3.5 text-[13px] leading-relaxed text-ivory-100" data-id="element-280" data-mp="3guq8rgtzo3k4">
                “{t.quote}”
              </blockquote>
              <footer className="mt-auto pt-4 text-[9px] font-medium uppercase tracking-[0.16em] text-muted" data-id="element-281" data-mp="3lqf8bk60dkgf">
                {t.name}
                <span className="ml-2 text-ivory-300" data-id="element-282" data-mp="3vitcskoh156a">{t.role}</span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}